import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

import LogoReconheca from 'assets/img/rebrand/reconheca-logo.png';
import ForcaFuturo from 'assets/img/rebrand/forca-futuro.png';
import { VERSION } from 'utils/constants';

import { IconDashboard, IconEquipe, IconFaq, IconGaleria, IconRecon, IconRegulamento } from './icons';

interface NavItemProps {
  to: string;
  icon: ReactNode;
  label: string;
  badge?: number;
  ariaLabel?: string;
}

interface SidebarProps {
  hasTeam: boolean;
  pendingApprovals?: number;
}

function NavItem({ to, icon, label, badge, ariaLabel }: NavItemProps) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link to={to} aria-label={ariaLabel || label} className={`rb-navitem ${isActive ? 'is-active' : ''}`}>
      {icon}
      <span>{label}</span>
      {!!badge && (
        <span className="rb-navitem__badge" title="Pendências de aprovação">
          {badge}
        </span>
      )}
    </Link>
  );
}

export function DashboardSidebar({ hasTeam, pendingApprovals }: SidebarProps) {
  return (
    <aside className="rb-sidebar" data-step="6">
      <div className="rb-sidebar__logos">
        <img src={LogoReconheca} alt="Reconheça BRB" className="rb-sidebar__logo" />
        <img src={ForcaFuturo} alt="Força que sustenta o futuro" className="rb-sidebar__forca" />
      </div>

      <nav className="rb-sidebar__nav">
        <NavItem to="/" icon={<IconDashboard size={19} />} label="Página Inicial" />
        <NavItem to="/extrato" icon={<IconRecon size={19} />} label="Meus Reconhecimentos" ariaLabel="Meus Reconhecimentos" />
        <NavItem to="/galeria" icon={<IconGaleria size={19} />} label="Galeria" ariaLabel="Galeria do Reconhecimento" />
        {hasTeam && (
          <NavItem
            to="/minha-equipe"
            icon={<IconEquipe size={19} />}
            label="Minha Equipe"
            badge={pendingApprovals}
            ariaLabel="Pendências de aprovação"
          />
        )}
        <NavItem to="/regulamento" icon={<IconRegulamento size={19} />} label="Regulamento" />
        <NavItem to="/ajuda" icon={<IconFaq size={19} />} label="Dúvidas Frequentes" ariaLabel="Dúvidas frequentes sobre o Reconheça BRB" />
      </nav>

      <div className="rb-sidebar__bottom">
        <div className="rb-sidebar__version" aria-hidden="true">
          {VERSION}
        </div>
      </div>
    </aside>
  );
}
